<template>
  <b-modal
    :active.sync="show"
    has-modal-card
    trap-focus
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-modal
    @cancel="$emit('input', false)"
    @close="$emit('input', false)"
  >
    <div v-if="hasError">
      hola salio error :C
    </div>
    <div
      v-if="Object.keys(data).length && !hasError"
      class="modal-card"
      style="min-width: 300px; max-width: 600px; margin: 1rem"
    >
      <header class="modal-card-head">
        <div class="modal-card-title">
          <b-icon icon="email" size="is-small" class="mr-2" />
          <span>Histórico de Correo - {{ data.name }}</span>
        </div>
      </header>

      <section
        class="modal-card-body"
        style="max-height: 70vh; overflow-y: auto;"
      >
        <div class="content-wrapper">
          <!-- Email Summary -->
          <div class="email-summary">
            <div class="columns is-multiline">
              <div class="column is-6">
                <label class="label is-small has-text-grey">Destinatario</label>
                <p class="is-size-7">{{ emailHistory.to }}</p>
              </div>
              <div class="column is-6">
                <label class="label is-small has-text-grey"
                  >Fecha de Envío</label
                >
                <p class="is-size-7">
                  {{ formatDate(emailHistory.sentAt) }} a las
                  {{ formatTime(emailHistory.sentAt) }}
                </p>
              </div>
              <div class="column is-6">
                <label class="label is-small has-text-grey">Asunto</label>
                <p class="is-size-7">{{ emailHistory.subject }}</p>
              </div>
              <div class="column is-6">
                <label class="label is-small has-text-grey"
                  >Última Actualización</label
                >
                <p class="is-size-7">
                  {{ formatDate(emailHistory.updatedAt) }} a las
                  {{ formatTime(emailHistory.updatedAt) }}
                </p>
              </div>
            </div>
          </div>

          <!-- Timeline -->
          <div class="timeline-section">
            <h3 class="title is-5 mb-4">Línea de Tiempo</h3>
            <div class="timeline-wrapper">
              <div
                v-for="(event, index) in emailHistory.events"
                :key="event.id"
                class="timeline-item"
              >
                <div class="timeline-marker-wrapper">
                  <div class="timeline-marker">
                    <b-icon
                      :icon="getEventIcon(event.type, event.active)"
                      size="is-small"
                      :type="getEventIconType(event.type, event.active)"
                    />
                  </div>
                  <div
                    v-if="index < emailHistory.events.length - 1"
                    class="timeline-line"
                  ></div>
                </div>
                <div class="timeline-content">
                  <div class="timeline-header">
                    <b-tag
                      :type="getEventTagType(event.type, event.active)"
                      size="is-small"
                    >
                      {{ getEventLabel(event.type, event.active) }}
                    </b-tag>
                    <span class="timeline-time is-size-7 has-text-grey">
                      {{ formatDate(event.timestamp) }} -
                      {{ formatTime(event.timestamp) }}
                    </span>
                  </div>
                  <p
                    class="timeline-description is-size-7 has-text-weight-medium"
                  >
                    {{ event.description }}
                  </p>
                  <p
                    v-if="event.details"
                    class="timeline-details is-size-7 has-text-grey"
                  >
                    {{
                      event.active
                        ? event.details
                        : "Sin movimientos en este estado"
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Stats -->
          <!-- <div class="stats-section">
            <div class="columns is-multiline is-mobile">
              <div class="column is-6-mobile is-3-tablet">
                <div class="stat-card">
                  <p class="stat-value has-text-info">1</p>
                  <p class="stat-label is-size-7 has-text-grey">Enviados</p>
                </div>
              </div>
              <div class="column is-6-mobile is-3-tablet">
                <div class="stat-card">
                  <p class="stat-value has-text-success">1</p>
                  <p class="stat-label is-size-7 has-text-grey">Entregados</p>
                </div>
              </div>
              <div class="column is-6-mobile is-3-tablet">
                <div class="stat-card">
                  <p class="stat-value has-text-purple">1</p>
                  <p class="stat-label is-size-7 has-text-grey">Abiertos</p>
                </div>
              </div>
              <div class="column is-6-mobile is-3-tablet">
                <div class="stat-card">
                  <p class="stat-value has-text-warning">1</p>
                  <p class="stat-label is-size-7 has-text-grey">Clicks</p>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </section>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "EmailHistoryModal",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: this.value,
      hasError: false,
      emailHistory: {
        _id: null,
        to: null,
        subject: null,
        sentAt: null,
        status: null,
        events: [],
      },
      eventsDetail: {
        sentSMTP: {
          id: 1,
          type: "sentSMTP",
          description: "Correo enviado",
          details: "Enviado desde el servidor SMTP principal",
          timestamp: null,
        },
        sent: {
          id: 2,
          type: "sent",
          description: "Correo entregado",
          details: "Entregado exitosamente al servidor de destino",
          timestamp: null,
        },
        opened: {
          id: 3,
          type: "opened",
          description: "Correo abierto",
          details: "Abierto por el usuario correctamente",
          timestamp: null,
        },
        clicked: {
          id: 4,
          type: "clicked",
          description: "Enlace clickeado",
          details: "Click en 'Ir a la encuesta'",
          timestamp: null,
        },
        bounced: {
          id: 5,
          type: "bounced",
          description: "Correo rebotado",
          details:
            "El mensaje no pudo ser entregado al destinatario (buzón lleno, dirección inexistente o rechazo del servidor).",
          timestamp: null,
        },
        softbounced: {
          id: 6,
          type: "softbounced",
          description: "Correo rebotado temporalmente",
          details:
            "El servidor del destinatario rechazó el mensaje, se reintentará pronto.",
          timestamp: null,
        },
        blocked: {
          id: 7,
          type: "blocked",
          description: "Correo bloqueado",
          details:
            "El servidor de destino bloqueó el correo antes de la entrega (posible política o reputación del remitente).",
          timestamp: null,
        },
        unsub: {
          id: 8,
          type: "unsub",
          description: "Destinatario desuscrito",
          details: "El destinatario se desuscribió usando el enlace de baja.",
          timestamp: null,
        },
        spam: {
          id: 9,
          type: "spam",
          description: "Marcado como spam",
          details:
            "El destinatario marcó el correo como spam en su bandeja de entrada.",
          timestamp: null,
        },
      },
    };
  },
  methods: {
    getData() {
      const blockedEventTypes = ["bounced", "softbounced", "blocked"];
      const flowDefault = ["sentSMTP", "sent", "opened", "clicked"];
      const dataEmail = this.data || {};

      this.emailHistory = {
        ...dataEmail,
        events: [],
      };

      if (dataEmail.status !== "success") {
        this.hasError = true;
        return;
      }

      let flow = Object.values(this.eventsDetail)
        .filter((e) => flowDefault.includes(e.type))
        .map((e) => ({
          ...e,
          active: flowDefault[0] === e.type,
          timestamp: e.type === "sentSMTP" ? dataEmail.sentAt : null,
        }));

      const history = dataEmail.history || [];

      const blockedEvent = history.find((e) =>
        blockedEventTypes.includes(e.eventType)
      );

      history.forEach((e) => {
        const item = flow.find((f) => f.type === e.eventType);
        if (item) {
          item.active = true;
          item.timestamp = e.eventAt;
        }
      });
      console.log(blockedEvent);

      if (blockedEvent) {
        console.log("Entra aqui");

        flow = flow.filter((e) => e.active);

        const events = Object.values(this.eventsDetail)
          .filter((e) => blockedEvent.eventType === e.type)
          .map((e) => ({
            ...e,
            active: true,
            timestamp: blockedEvent.eventAt,
          }));

        flow.push(...events);
      }

      return (this.emailHistory.events = flow);
    },
    getEventIcon(type, active) {
      if (!active) return "clock";
      const icons = {
        sentSMTP: "email-fast-outline",
        sent: "check-circle",
        opened: "eye",
        clicked: "cursor-default-click",
        bounced: "email-alert-outline",
        softbounced: "alert-circle",
        blocked: "cancel",
        unsub: "account-off-outline",
        spam: "alert",
      };
      return icons[type] || "clock";
    },
    getEventIconType(type, active) {
      if (!active) return "";
      const types = {
        sentSMTP: "is-info",
        sent: "is-success",
        opened: "is-purple",
        clicked: "is-warning",
        bounced: "is-danger",
        softbounced: "is-danger",
        blocked: "is-danger",
        unsub: "is-warning",
        spam: "is-danger",
      };
      return types[type] || "";
    },
    getEventTagType(type, active) {
      if (!active) return "";
      const types = {
        sentSMTP: "is-info is-light",
        sent: "is-success is-light",
        opened: "is-purple is-light",
        clicked: "is-warning is-light",
        bounced: "is-danger is-light",
        softbounced: "is-danger is-light",
        blocked: "is-danger is-light",
        unsub: "is-warning is-light",
        spam: "is-danger is-light",
      };
      return types[type] || "is-light";
    },
    getEventLabel(type, active) {
      if (!active) {
        const labelsInactive = {
          sentSMTP: "Sin enviar",
          sent: "Sin entregar",
          opened: "Sin abrir",
          clicked: "Sin clickear",
        };

        return labelsInactive[type];
      }

      const labels = {
        sentSMTP: "Enviado",
        sent: "Entregado",
        opened: "Abierto",
        clicked: "Clickeado",
        bounced: "Rebotado",
        softbounced: "Rebotado temporal",
        spam: "Spam",
      };
      return labels[type] || type;
    },
    formatTime(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp);
      return date.toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    formatDate(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp);
      return date.toLocaleDateString("es-ES");
    },
  },
  watch: {
    value(newVal) {
      if (newVal) this.getData();
      this.show = newVal;
    },
    show(newVal) {
      this.$emit("input", newVal);
    },
  },
};
</script>

<style scoped>
.content-wrapper {
  padding: 0.5rem 0;
}

/* Email Summary */
.email-summary {
  background-color: #f5f5f5;
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1.5rem;
}

.email-summary .label {
  margin-bottom: 0.25rem;
  font-weight: 500;
}

/* Timeline */
.timeline-section {
  margin-bottom: 1.5rem;
}

.timeline-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.timeline-item {
  display: flex;
  gap: 1rem;
}

.timeline-marker-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0.25rem;
}

.timeline-marker {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background-color: white;
  border: 2px solid #dbdbdb;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.timeline-line {
  width: 1px;
  flex: 1;
  background-color: #dbdbdb;
  margin-top: 0.5rem;
  min-height: 2rem;
}

.timeline-content {
  flex: 1;
  padding-bottom: 0.5rem;
}

.timeline-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.25rem;
  flex-wrap: wrap;
}

.timeline-time {
  white-space: nowrap;
}

.timeline-description {
  margin-bottom: 0.25rem;
}

.timeline-details {
  margin-top: 0.25rem;
}

/* Stats */
.stats-section {
  margin-top: 1.5rem;
}

.stat-card {
  background-color: white;
  border: 1px solid #dbdbdb;
  border-radius: 6px;
  padding: 0.75rem;
  text-align: center;
}

.stat-value {
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 0.25rem;
}

.stat-label {
  margin: 0;
}

/* Color for purple */
.has-text-purple {
  color: #b86bff !important;
}

.is-purple {
  background-color: #b86bff;
  color: white;
}

.is-purple.is-light {
  background-color: #f3e5ff;
  color: #7c3aed;
}

/* Modal */
.modal-card-body {
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

.modal-card-title {
  display: flex;
  align-items: center;
  font-weight: 600;
}

.modal-card-foot {
  justify-content: flex-end;
}

/* Responsive */
@media screen and (max-width: 768px) {
  .timeline-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .stat-card {
    padding: 0.5rem;
  }

  .stat-value {
    font-size: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/components/Collaborator/EmailHistoryModal.vue